import React from 'react';
import styled from 'styled-components';

import DropdownIndicator from '../../../../icons/DropdownIndicator';
import RoundedSquare from '../../../../layouts/RoundedSquare';
import ColorConstants from '../../../../../constants/ColorConstants';
import interfaceText from '../../../../../i18n/interfaceText';
import { MobileScreen } from '../../../../styles/ConstantMediaQuery';

const defaultProps = {
    placeholder: interfaceText.placeholder,
};

const SingleValueWithDropDown = ({ placeholder, ...props }) => (
    <StyledRoundedSquare {...props}>
        {placeholder}
        <DropdownIndicator height="11px" width="11px" />
    </StyledRoundedSquare>
);

const StyledRoundedSquare = styled(RoundedSquare)`
    color: ${ColorConstants['regal-blue']};
    cursor: pointer;
    display: flex;
    font-weight: 400;
    height: 43px;
    justify-content: space-between;
    padding-left: 15px;
    
    @media ${MobileScreen} {
        width: 100%;
    }
`;

SingleValueWithDropDown.defaultProps = defaultProps;

export default SingleValueWithDropDown;
